function initialize(root=document){
  root.querySelectorAll('[data-mm-variant]').forEach(select=>{
    if(select.dataset.initialized)return;
    select.dataset.initialized='true';
    const choose=()=>{const url=new URL(location.href);url.searchParams.set('variant',select.value);url.hash='gel-details';location.assign(url);};
    select.addEventListener('change',choose);
    const hash=location.hash.slice(1),option=[...select.options].find(o=>o.dataset.name===hash);
    if(option&&option.value!==select.value){select.value=option.value;choose();}
  });
}
document.addEventListener('click',event=>{
  const toggle=event.target.closest('.menu-toggle');
  if(toggle){const menu=document.getElementById(toggle.getAttribute('aria-controls'));const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));menu.hidden=!open;}
  const flavour=event.target.closest('.flavour-image');
  if(flavour){const open=flavour.getAttribute('aria-expanded')!=='true';flavour.setAttribute('aria-expanded',String(open));flavour.closest('.flavour-card')?.classList.toggle('is-open',open);}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.mobile-menu').forEach(n=>n.hidden=true);document.querySelectorAll('.menu-toggle').forEach(n=>n.setAttribute('aria-expanded','false'));}});
initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
